import { render, staticRenderFns } from "./IntegralGoodsDetail.vue?vue&type=template&id=48ea7c0c&scoped=true&"
import script from "./IntegralGoodsDetail.vue?vue&type=script&lang=js&"
export * from "./IntegralGoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./IntegralGoodsDetail.vue?vue&type=style&index=0&id=48ea7c0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea7c0c",
  null
  
)

export default component.exports